import React, { useState, forwardRef, useImperativeHandle } from "react";
import {Button,
        Dialog,
        DialogActions,
        DialogContent,
        DialogContentText,
        DialogTitle,
        CircularProgress
} from "@material-ui/core";

import { sendNotification } from "../../context/UserContext";
import useStyles from './styles';
import ttAPI from '../../api/ttAPI';

const JobConfirmation = forwardRef((props, ref) => {
    const { closeMenu, onConfirmationSuccess } = props;
    const classes = useStyles();
    const [jobId, setJobId] = useState(-1);
    const [openConfirmJobDialog, setOpenConfirmJobDialog] = useState(false);
    const [isConfirming, setIsConfirming] = useState(false);

    useImperativeHandle(ref, () => ({

      openConfirmationPopup(jobId) {
        setJobId(jobId);
        handleClickJobConfirmationPopup();
      }

    }));


    const handleClickJobConfirmationPopup = () => {
      //closeMenu(); // handle closing menu after confirmation success and teams chat is opened, so don't do it here
      setOpenConfirmJobDialog(true);
    };

    const handleCloseConfirmationJob = () => {
      setOpenConfirmJobDialog(false);
    };

    const handleConfirmJob = async() => {
      setIsConfirming(true);
      const response = await ttAPI.confirmJob(jobId);
      setIsConfirming(false);

      if (response) {
          sendNotification('success', `Success - Job ${jobId} confirmed.`, classes);
          handleCloseConfirmationJob();
          onConfirmationSuccess();
      }
      else {
          sendNotification('error', `Error - Job ${jobId} NOT confirmed.`, classes);
      }
    };


  return (
    <>
    <Dialog open={openConfirmJobDialog} onClose={handleCloseConfirmationJob} disableBackdropClick={true}

        PaperProps={{
          style: {
            boxShadow: 'none',
          },
        }}
    >
      <DialogTitle id="form-dialog-title">Confirm Job</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to confirm job {jobId}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseConfirmationJob} className={classes.cancelButton}>
          Cancel
        </Button>
          <Button onClick={handleConfirmJob} disabled={isConfirming}>
            {isConfirming && <span><CircularProgress size={25}/> Confirming...</span>}
            {!isConfirming && <span>Confirm</span>}
          </Button>
      </DialogActions>
    </Dialog>
    </>
  );
});
export default JobConfirmation;
